import { ChangeEventHandler, RefObject, useRef } from "react"
import {
  useMoneyInput,
  UseMoneyInputProps,
} from "shared-ts/hooks/useInput/useMoneyInput"

import { TextInput, TextInputProps } from "../TextInput"

export interface TextMoneyInputProps
  extends Omit<TextInputProps, "leftText">,
    UseMoneyInputProps {
  leftText?: "$" | null
  ref?: RefObject<HTMLInputElement | null>
}

export const TextMoneyInput = ({
  money,
  onChangeMoney,
  onBlurMoney,
  ref,
  leftText = "$",
  ...otherProps
}: TextMoneyInputProps) => {
  const { value, handleChange, handleBlur, handleFocus } = useMoneyInput({
    money,
    onChangeMoney,
    onBlurMoney,
  })

  const innerRef = useRef<HTMLInputElement>(null)
  const inputRef = ref ?? innerRef

  const handleChangeEvent: ChangeEventHandler<HTMLInputElement> = (e) => {
    const raw = e.currentTarget.value
    handleChange(raw)
  }

  return (
    <TextInput
      ref={inputRef}
      leftText={leftText ?? undefined}
      onChange={handleChangeEvent}
      onBlur={handleBlur}
      value={value}
      onFocus={handleFocus}
      {...otherProps}
    />
  )
}
